export enum ContactType {
  Company = 'company',
  Person = 'person',
}
